import React, { useState } from 'react';
import { Button } from 'modules';
import DebtModal, { DebtData } from './DebtModal';

interface ButtonAddProps {
  disabled?: boolean;
  onSubmit: (data: DebtData) => void;
}

const ButtonAdd = ({ disabled = false, onSubmit }: ButtonAddProps) => {
  const [showModal, setShowModal] = useState(false);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <Button type="button" variant="danger" disabled={disabled} onClick={toggleShowModal}>
        Pridať veriteľa
      </Button>

      {showModal && <DebtModal onHide={toggleShowModal} onSubmit={onSubmit} />}
    </>
  );
};

export default ButtonAdd;
